import Container from 'app/components/base/Container'
import Divider from 'app/components/base/Divider'
import Paper from 'app/components/base/Paper'
import Stack from 'app/components/base/Stack'
import { useGetHelpCenterArticles } from 'app/services/Query/help-center/help-center.query'
import { HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER } from 'app/utils/constants/help-center.constants'

import SearchEmptyState from './components/SearchEmptyState'
import SearchResultCard from './components/SearchResultCard'
import SearchTotal from './components/SearchTotal'

interface HelpCenterSearchFeatureProps {
  keyword: string
}

const HelpCenterSearchFeature = ({ keyword }: HelpCenterSearchFeatureProps) => {
  const { data, isFetching, isPlaceholderData } = useGetHelpCenterArticles({
    params: { byKeyword: keyword },
    options: {
      enabled: !!keyword,
      placeholderData: HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER,
      keepPreviousData: true
    }
  })

  const articles = data?.articles
  const articlesCount = articles?.length || 0

  const isLoading = isFetching || isPlaceholderData
  const isEmptyState = !isLoading && !articlesCount

  return (
    <Container
      maxWidth="md"
      sx={{
        px: 2,
        pt: { xs: 3, md: 8 },
        pb: 7
      }}
    >
      <Stack direction="column" spacing={3}>
        {isEmptyState && <SearchEmptyState />}

        {!isEmptyState && (
          <>
            <SearchTotal
              articlesCount={articlesCount}
              keyword={keyword}
              isLoading={isLoading}
            />

            <Paper>
              <Stack direction="column" spacing={2} divider={<Divider />}>
                {articles?.map((item, index) => {
                  const isLastItem = index === articles?.length - 1
                  const link = `/help-centre/${item.primary_help_center_category?.slug}/${item.slug}`

                  return (
                    <SearchResultCard
                      key={item.id}
                      title={item.title}
                      link={link}
                      preview={item.body_preview}
                      isLoading={isLoading}
                      isLastItem={isLastItem}
                    />
                  )
                })}
              </Stack>
            </Paper>
          </>
        )}
      </Stack>
    </Container>
  )
}

export default HelpCenterSearchFeature
